module.exports = __webpack_public_path__ + "static/media/6_1600867549635.c9a014cc.3";